import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberNameSkeleton } from './subcomponents/skeleton';
import { MemberNameUI } from './subcomponents/ui';
import { defaultMemberNameProps, memberNamePropsValidator } from './types/props';
export const MemberName = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { member } = useMemberContext();
    if (!member)
        return enableSkeletonLoadingIndicators ? _jsx(MemberNameSkeleton, {}) : null;
    return _jsx(MemberNameUI, Object.assign({}, props, { name: member.personalDetails.name }));
});
MemberName.displayName = 'MemberName';
/**
 * The **Member Name** component renders the currently logged-in Loyalty member's name.
 */
export const MemberNameComponent = withComponentWrapper(MemberName, defaultMemberNameProps, memberNamePropsValidator);
